import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { isMeWeTeam } from 'mewe/helpers/is-mewe-team';
import { allowInternalTools } from 'mewe/helpers/allow-internal-tools';

export default class ApplicationController extends Controller {
  @service('dynamic-dialogs') dialogs;
  @service('dynamic-popups') popups;

  constructor() {
    super(...arguments);

    if (allowInternalTools()) {
      this.setupKeyListeners();
    }
  }

  willDestroy() {
    super.willDestroy(...arguments);
    this.cleanupKeyListeners();
  }

  @action
  switchCodeVersion(e) {
    e.preventDefault();
    this.dynamicDialogs.openDialog('debug-tool-dialog');
  }

  @action
  setupKeyListeners() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  @action
  cleanupKeyListeners() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  @action
  handleKeyDown(event) {
    // Check if Command (metaKey) and Shift are pressed along with the '\' key (whose keyCode is 220)
    if (event.shiftKey && event.metaKey && event.keyCode === 220) {
      this.dialogs.openDialog('debug-tool-dialog');
    }

    if (event.shiftKey && event.altKey && event.code === 'KeyD') {
      this.dialogs.openDialog('debug-dialog');
    }

  }
}
